import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { getPendingQuery } from "../redux/slices/pastSessionSlice";
import { AppDispatch } from "../redux/store";
import { PendingQueryResponseStatus } from "../components/ChatMessage/constants";

export const usePollPendingQuery = (sessionId: string | null, interval = 5000, maxAttempts = 60) => {
  const dispatch = useDispatch<AppDispatch>();
  const attemptsRef = useRef(0);
  const intervalIdRef = useRef<NodeJS.Timeout | null>(null);

  const poll = async () => {
    try {
      attemptsRef.current++;
      const result = await dispatch(getPendingQuery({ sessionId })).unwrap();
      if (!result || result.status !== PendingQueryResponseStatus.IS_STREAMING) {
        stopPolling();
      }

      if (attemptsRef.current > maxAttempts) {
        stopPolling();
      }
    }
    catch (err) {
      console.error("Error when polling for pending query: ", err);
      stopPolling();
    }
  };

  const stopPolling = () => {
    if (intervalIdRef.current) {
      clearTimeout(intervalIdRef.current);
      intervalIdRef.current = null;
    }
  };

  useEffect(() => {
    if (!sessionId) return;

    attemptsRef.current = 0;

    poll(); // first call should be immediate
    intervalIdRef.current = setInterval(poll, interval);

    return () => {
      stopPolling();
    };
  }, [sessionId, interval, maxAttempts]);
};
